<template>
      <card>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="false"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
      </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "value",
      fields: [
         {
              label: "Название",
              key: "title",
              type: "field",
              textType: "text", 
              isMultiLang:true
            },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_value",
      itemLink: "warehouse/values",
      setLink: "warehouse/values",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
          // sortBy:'id'
        },
        {
          key: "title",
          title: "Наименование",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
